<template>
  <div>
    <proceeding-info v-model="proceeding.info"/>
    <div v-if="isStaff">
      <p class="title bottom-line"><mdb-icon far icon="comment-alt" />운영 매니저 의견</p>
      <proceeding-comment-edit v-if="managerMode === 'EDIT'" v-model="proceeding.manager"/>
      <proceeding-comment-view v-else :content="proceeding.manager"/>

      <p class="title bottom-line"><mdb-icon far icon="comment-alt" /> 훈련 강사 의견</p>
      <proceeding-comment-view :content="proceeding.teacher"/>

      <p class="title bottom-line"><mdb-icon far icon="comment-alt" />총괄 매니저 의견</p>
      <proceeding-comment-edit v-if="chiefMode === 'EDIT'" v-model="proceeding.chief"/>
      <proceeding-comment-view v-else :content="proceeding.chief"/>
    </div>
    <div v-else>
      <p class="title bottom-line"><mdb-icon far icon="comment-alt" /> 운영 매니저 의견</p>
      <proceeding-comment-view :content="proceeding.manager"/>

      <p class="title bottom-line"><mdb-icon far icon="comment-alt" />
        훈련 강사 의견 <edit-btn-sm v-if="teacherMode == 'VIEW'" @click="teacherMode = 'EDIT'">수정</edit-btn-sm>
      </p>
      <proceeding-comment-edit v-if="teacherMode === 'EDIT'" :content="proceeding.teacher" @cancel="teacherMode='VIEW'"/>
      <proceeding-comment-view v-else :content="proceeding.teacher"/>

      <p class="title bottom-line"><mdb-icon far icon="comment-alt" /> 총괄 매니저 의견</p>
      <proceeding-comment-view :content="proceeding.chief"/>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import Proceeding from '@/models/Proceeding'
import ProceedingCommentView from './ProceedingCommentView.vue';
import ProceedingCommentEdit from './ProceedingCommentEdit.vue';
import ProceedingInfo from './ProceedingInfo.vue';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'ProceedingEdit',
  components: { ProceedingInfo, ProceedingCommentView, ProceedingCommentEdit },
  props: ['value'],
  data: function () {
    return {
      proceeding: this.$clone(this.value),
      managerMode: 'VIEW',
      teacherMode: 'VIEW',
      chiefMode: 'VIEW'
    }
  },
  computed: {
    ...mapGetters('auth', ['isTeacher', 'isStaff'])
  },
  methods: {
    init () {
      this.proceeding = this.$clone(this.value)
    }
  },
  watch: {
    value () { this.init() }
  }
}
</script>
